// @generated by protoc-gen-es v2.12.1 with parameter "target=ts"
// @generated from file api/gateway/v1/installation_data.proto (package gateway.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Pagination, PaginationMetadata } from "./core_pb";
import { file_api_gateway_v1_core } from "./core_pb";
import { file_google_protobuf_struct } from "@bufbuild/protobuf/wkt";
import type { JsonObject, Message } from "@bufbuild/protobuf";

/**
 * Describes the file api/gateway/v1/installation_data.proto.
 */
export const file_api_gateway_v1_installation_data: GenFile = /*@__PURE__*/
  fileDesc("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", [file_api_gateway_v1_core, file_google_protobuf_struct]);

/**
 * GetInstallationDataTelemetryByPageRequest is the request message for retrieving telemetry data for a specific installation and topic, with pagination support.
 *
 * @generated from message gateway.v1.GetInstallationDataTelemetryByPageRequest
 */
export type GetInstallationDataTelemetryByPageRequest = Message<"gateway.v1.GetInstallationDataTelemetryByPageRequest"> & {
  /**
   * installation_uuid is the unique identifier of the installation to retrieve telemetry data for.
   *
   * @generated from field: string installation_uuid = 1;
   */
  installationUuid: string;

  /**
   * topic is the specific data topic to filter telemetry data by. Use INSTALLATION_DATA_TOPIC_UNSPECIFIED to include both level topics.
   *
   * @generated from field: gateway.v1.InstallationDataTopic topic = 2;
   */
  topic: InstallationDataTopic;

  /**
   * pagination contains the pagination parameters for retrieving a specific page of telemetry data.
   *
   * @generated from field: gateway.v1.Pagination pagination = 3;
   */
  pagination?: Pagination | undefined;
};

/**
 * Describes the message gateway.v1.GetInstallationDataTelemetryByPageRequest.
 * Use `create(GetInstallationDataTelemetryByPageRequestSchema)` to create a new message.
 */
export const GetInstallationDataTelemetryByPageRequestSchema: GenMessage<GetInstallationDataTelemetryByPageRequest> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_installation_data, 0);

/**
 * GetInstallationDataTelemetryByPageResponse is the response message for retrieving telemetry data for a specific installation and topic, with pagination support.
 *
 * @generated from message gateway.v1.GetInstallationDataTelemetryByPageResponse
 */
export type GetInstallationDataTelemetryByPageResponse = Message<"gateway.v1.GetInstallationDataTelemetryByPageResponse"> & {
  /**
   * data is the list of telemetry data entries, each represented as a Struct for flexible schema.
   *
   * @generated from field: repeated google.protobuf.Struct data = 1;
   */
  data: JsonObject[];

  /**
   * metadata contains additional information about the pagination.
   *
   * @generated from field: gateway.v1.PaginationMetadata metadata = 2;
   */
  metadata?: PaginationMetadata | undefined;
};

/**
 * Describes the message gateway.v1.GetInstallationDataTelemetryByPageResponse.
 * Use `create(GetInstallationDataTelemetryByPageResponseSchema)` to create a new message.
 */
export const GetInstallationDataTelemetryByPageResponseSchema: GenMessage<GetInstallationDataTelemetryByPageResponse> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_installation_data, 1);

/**
 * GetInstallationLatestDataTelemetryRequest is the request message for retrieving the latest telemetry data for a specific installation and topic.
 *
 * @generated from message gateway.v1.GetInstallationLatestDataTelemetryRequest
 */
export type GetInstallationLatestDataTelemetryRequest = Message<"gateway.v1.GetInstallationLatestDataTelemetryRequest"> & {
  /**
   * installation_uuid is the unique identifier of the installation to retrieve telemetry data for.
   *
   * @generated from field: string installation_uuid = 1;
   */
  installationUuid: string;

  /**
   * topic is the specific data topic to filter telemetry data by. Use INSTALLATION_DATA_TOPIC_UNSPECIFIED to include both level topics.
   *
   * @generated from field: gateway.v1.InstallationDataTopic topic = 2;
   */
  topic: InstallationDataTopic;
};

/**
 * Describes the message gateway.v1.GetInstallationLatestDataTelemetryRequest.
 * Use `create(GetInstallationLatestDataTelemetryRequestSchema)` to create a new message.
 */
export const GetInstallationLatestDataTelemetryRequestSchema: GenMessage<GetInstallationLatestDataTelemetryRequest> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_installation_data, 2);

/**
 * GetInstallationLatestDataTelemetryResponse is the response message for retrieving the latest telemetry data for a specific installation and topic.
 *
 * @generated from message gateway.v1.GetInstallationLatestDataTelemetryResponse
 */
export type GetInstallationLatestDataTelemetryResponse = Message<"gateway.v1.GetInstallationLatestDataTelemetryResponse"> & {
  /**
   * data is the list of latest telemetry data entries, each represented as a Struct for flexible schema.
   *
   * @generated from field: repeated google.protobuf.Struct data = 1;
   */
  data: JsonObject[];
};

/**
 * Describes the message gateway.v1.GetInstallationLatestDataTelemetryResponse.
 * Use `create(GetInstallationLatestDataTelemetryResponseSchema)` to create a new message.
 */
export const GetInstallationLatestDataTelemetryResponseSchema: GenMessage<GetInstallationLatestDataTelemetryResponse> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_installation_data, 3);

/**
 * GetInstallationDataTelemetryByCursorRequest is the request message for retrieving telemetry data using cursor pagination.
 *
 * @generated from message gateway.v1.GetInstallationDataTelemetryByCursorRequest
 */
export type GetInstallationDataTelemetryByCursorRequest = Message<"gateway.v1.GetInstallationDataTelemetryByCursorRequest"> & {
  /**
   * installation_uuid is the unique identifier of the installation to retrieve telemetry data for.
   *
   * @generated from field: string installation_uuid = 1;
   */
  installationUuid: string;

  /**
   * topic is the specific data topic to filter telemetry data by. Use INSTALLATION_DATA_TOPIC_UNSPECIFIED to include both level topics.
   *
   * @generated from field: gateway.v1.InstallationDataTopic topic = 2;
   */
  topic: InstallationDataTopic;

  /**
   * page_size is the maximum number of telemetry rows to retrieve.
   *
   * @generated from field: uint32 page_size = 3;
   */
  pageSize: number;

  /**
   * cursor is an opaque token returned by the previous response. Leave empty for the first page.
   *
   * @generated from field: string cursor = 4;
   */
  cursor: string;
};

/**
 * Describes the message gateway.v1.GetInstallationDataTelemetryByCursorRequest.
 * Use `create(GetInstallationDataTelemetryByCursorRequestSchema)` to create a new message.
 */
export const GetInstallationDataTelemetryByCursorRequestSchema: GenMessage<GetInstallationDataTelemetryByCursorRequest> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_installation_data, 4);

/**
 * GetInstallationDataTelemetryByCursorResponse is the response message for retrieving telemetry data using cursor pagination.
 *
 * @generated from message gateway.v1.GetInstallationDataTelemetryByCursorResponse
 */
export type GetInstallationDataTelemetryByCursorResponse = Message<"gateway.v1.GetInstallationDataTelemetryByCursorResponse"> & {
  /**
   * data is the list of telemetry data entries, each represented as a Struct for flexible schema.
   *
   * @generated from field: repeated google.protobuf.Struct data = 1;
   */
  data: JsonObject[];

  /**
   * next_cursor is an opaque token for the next page. It is empty when there are no more rows.
   *
   * @generated from field: string next_cursor = 2;
   */
  nextCursor: string;

  /**
   * has_more indicates whether more rows are available after this page.
   *
   * @generated from field: bool has_more = 3;
   */
  hasMore: boolean;
};

/**
 * Describes the message gateway.v1.GetInstallationDataTelemetryByCursorResponse.
 * Use `create(GetInstallationDataTelemetryByCursorResponseSchema)` to create a new message.
 */
export const GetInstallationDataTelemetryByCursorResponseSchema: GenMessage<GetInstallationDataTelemetryByCursorResponse> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_installation_data, 5);

/**
 * InstallationDataTopic defines the specific topics for installation telemetry data.
 *
 * @generated from enum gateway.v1.InstallationDataTopic
 */
export enum InstallationDataTopic {
  /**
   * @generated from enum value: INSTALLATION_DATA_TOPIC_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: INSTALLATION_DATA_TOPIC_PUBLIC_SEWER_LEVEL = 1;
   */
  PUBLIC_SEWER_LEVEL = 1,

  /**
   * @generated from enum value: INSTALLATION_DATA_TOPIC_PRIVATE_SEWER_LEVEL = 2;
   */
  PRIVATE_SEWER_LEVEL = 2,
}

/**
 * Describes the enum gateway.v1.InstallationDataTopic.
 */
export const InstallationDataTopicSchema: GenEnum<InstallationDataTopic> = /*@__PURE__*/
  enumDesc(file_api_gateway_v1_installation_data, 0);

/**
 * InstallationDataService defines the gRPC service for retrieving installation telemetry data.
 *
 * @generated from service gateway.v1.InstallationDataService
 */
export const InstallationDataService: GenService<{
  /**
   * GetInstallationDataTelemetryByTopic retrieves telemetry data for a specific installation and topic, with pagination support.
   *
   * @generated from rpc gateway.v1.InstallationDataService.GetInstallationDataTelemetryByPage
   */
  getInstallationDataTelemetryByPage: {
    methodKind: "unary";
    input: typeof GetInstallationDataTelemetryByPageRequestSchema;
    output: typeof GetInstallationDataTelemetryByPageResponseSchema;
  },
  /**
   * GetInstallationLatestDataTelemetry retrieves the latest telemetry data for a specific installation and topic.
   *
   * @generated from rpc gateway.v1.InstallationDataService.GetInstallationLatestDataTelemetry
   */
  getInstallationLatestDataTelemetry: {
    methodKind: "unary";
    input: typeof GetInstallationLatestDataTelemetryRequestSchema;
    output: typeof GetInstallationLatestDataTelemetryResponseSchema;
  },
  /**
   * GetInstallationDataTelemetryByCursor retrieves telemetry data using cursor pagination.
   *
   * @generated from rpc gateway.v1.InstallationDataService.GetInstallationDataTelemetryByCursor
   */
  getInstallationDataTelemetryByCursor: {
    methodKind: "unary";
    input: typeof GetInstallationDataTelemetryByCursorRequestSchema;
    output: typeof GetInstallationDataTelemetryByCursorResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_api_gateway_v1_installation_data, 0);

